import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useSendWebEvent } from "~/hooks";
import { useAppDispatch } from "~/providers/app/hooks";
import { authActions } from "~/providers/store/auth";
import { isWebBrowser, setWebTillId } from "~/utils/web";
import { logger } from "~/services/logger";

import { tillsKeys } from "../keys";
import { updateTill } from "../requests";
import { type UpdateTillRequest } from "../types";

export function useAssignTill() {
  const dispatch = useAppDispatch();
  const sendWebEvent = useSendWebEvent();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({
      tillId,
      deviceId
    }: Pick<UpdateTillRequest["body"], "deviceId"> & {
      tillId: string;
    }) => updateTill(tillId, { deviceId }),
    onSuccess: (till) => {
      void queryClient.invalidateQueries({
        queryKey: tillsKeys.detail(till.id)
      });

      dispatch({
        type: "DEVICE_ASSIGN_TILL",
        payload: till.id
      });

      sendWebEvent({
        type: "DEVICE_DATA_SET_REQUEST",
        payload: { tillId: till.id }
      });

      // WEB - set till id in local storage
      const isWeb = isWebBrowser();
      if (isWeb) {
        setWebTillId(till.id);
      }

      authActions.assignTill({
        moduleId: till.moduleId,
        userId: till.moduleId,
        schoolId: till.schoolId,
        tillId: till.id
      });

      logger.trace(`Till assigned - ${isWeb ? "web" : "app"}`, {
        till_id: till.id,
        device_id: till.deviceId
      });

      navigate("/profiles");
    }
  });
}
